import { useEffect, useState } from 'react';
import { Panel } from 'react-bootstrap';
import Select from 'react-select';


import '../../Assets/Ui/RequestCounter.css';

import { fetchApi } from '../../Network/NetworkService';
import { notif } from './Notification';

const LeadCapitalCounter = (props) => {

    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [siteConf, setSiteConf] = useState({})


    const getCount = () => {
        setLoading(true);
        
        fetchApi(`/leadCapital/count${props.selectedType ? `?type=${props.selectedType.value}`: ''}`)
            .then((res) => {
                setCount(res.count);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                notif.addNotification(
                                    'Erreur',
                                    'Erreur survenue ' + err,
                                    'warning'
                                )
            });
    };

    const getSiteSetting = () => {
        fetchApi(`/siteConf`)
            .then((res) => {                
                setSiteConf(res)
            })
            .catch((err) => {
                notif.addNotification(
                                    'Erreur',
                                    'Erreur survenue ' + err,
                                    'warning'
                                )
            });
    }

    const setSiteSetting = () => {
        fetchApi(`/siteConf`, { method: 'PUT', body: JSON.stringify({ activateCapital: !siteConf.activateCapital }) })
            .then((res) => {
                setSiteConf(res)
                getSiteSetting()
            })
            .catch((err) => {
                notif.addNotification(
                                    'Erreur',
                                    'Erreur survenue ' + err,
                                    'warning'
                                )
            });
    }

    useEffect(() => {
        getCount();
        getSiteSetting()
    }, []);

    useEffect(() => {
        getCount()
    }, [props.selectedType])

    return (
        <Panel>
            <Panel.Heading>
                <h6>Compteur</h6>
            </Panel.Heading>
            <Panel.Body>
                <div className="counter">
                    <div className="filter-block">
                        <button type='button' className='button-export' onClick={setSiteSetting} disabled={loading}>
                            {siteConf.activateCapital ? 'Désactiver' : 'Activer'} la file d'attente
                        </button>
                       <div style={{ margin: '20px 0'}}>
                            <Select
                                value={props.selectedType}
                                onChange={props.setSelectedType}
                                options={props.typeList}
                                isClearable
                                styles={{ option: (s) => ({
                                    ...s,
                                    color: 'black',
                                })}}
                                role="checkbox"
                                placeholder="Filtre par pathologie" 
                            />
                       </div>
                        <div>
                            <button className='button-export' type='button' onClick={props.sendRelance} disabled={siteConf.activateCapital || props.relanceLoading}>Envoyer les relances</button>
                        </div>
                    </div>


                    <div className="nb-block">
                        <Panel>
                            <Panel.Heading>
                                <h3>Total</h3>
                                {loading ? (
                                    <span className="loader" />
                                ) : (
                                    <h2>{count}</h2>
                                )}
                            </Panel.Heading>
                        </Panel>
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
};

export default LeadCapitalCounter;
